import React, { useEffect, useState } from 'react'
import * as S from './styles'

import Shortcut from '../Shortcut'

import { useModal } from '@/contexts/ModalContext'

import { useTranslation } from 'react-i18next'

const SectionsShortcut = () => {
  const { settings } = useModal()
  const { t } = useTranslation()

  const [commandInfo, setCommandInfo] = useState()
  const [bladesShortcutMessage, setBladesShortcutMessage] = useState()

  useEffect(() => {
    setBladesShortcutMessage(t('subtitles.bladeMessage'))
    setCommandInfo({
      blades: [
        { name: t('subtitles.rotate'), key: 'r' },
        { name: t('subtitles.turn'), key: 'f' },
        { name: t('subtitles.textbox'), key: 'c' }
      ],
      models: [
        {
          shortCutListTitle: '',
          shortcuts: [
            { name: t('subtitles.deselect'), key: ['delete', 'return'] },
            { name: t('subtitles.nextChapter'), key: 'l' },
            { name: t('subtitles.previousChapter'), key: 'k' },
            { name: t('subtitles.fullscreen'), key: 'Enter' },
            { name: t('subtitles.detail'), key: 'i' },
            { name: t('subtitles.help'), key: 'u' },
            { name: t('subtitles.textbox'), key: 't' },
            { name: t('subtitles.saveNew'), key: 'Ctrl + j' },
            { name: t('subtitles.save'), key: 'Ctrl + s' },
            { name: t('subtitles.cutTool'), key: 'f' },
            { name: t('subtitles.tag'), key: 'g' },
            { name: t('subtitles.rotate'), key: 'h' },
            { name: t('subtitles.animationPanel'), key: 'j' },
            { name: t('subtitles.tree'), key: 'y' }
          ]
        },
        {
          shortCutListTitle: t('subtitles.basicTools'),
          shortcuts: [
            { name: t('subtitles.select'), key: 'z' },
            { name: t('subtitles.recentralize'), key: 'x' },
            { name: t('subtitles.focus'), key: 'c' },
            { name: t('subtitles.selectMultiple'), key: 'v' },
            { name: t('subtitles.hide'), key: 'b' },
            { name: t('subtitles.isolate'), key: 'n' },
            { name: t('subtitles.undoAction'), key: 'Ctrl + z' },
            { name: t('subtitles.advanceAction'), key: 'Ctrl + x' },
            { name: t('subtitles.reset'), key: 'Ctrl + r' }
          ]
        },
        {
          shortCutListTitle: t('subtitles.animationControl'),
          shortcuts: [
            { name: t('subtitles.playPause'), key: 'Ctrl + p' },
            { name: t('subtitles.restartAnimation'), key: 'Ctrl + g' },
            { name: t('subtitles.speed'), key: 'Ctrl + h' },
            { name: t('subtitles.ClosePanelMinimize'), key: 'j' }
          ]
        }
      ]
    })
  }, [t])

  return (
    <div id="section-shortcut" className="help-section">
      {commandInfo &&
        commandInfo[settings.config.type].map(
          ({ shortCutListTitle, shortcuts }) =>
            shortcuts?.length > 0 && (
              <S.ShortCutSection key={shortCutListTitle}>
                {shortCutListTitle && (
                  <h3 className="title">{shortCutListTitle}</h3>
                )}
                {shortcuts.map(({ name, key }) => (
                  <S.RowContainer
                    className="flexbox h-spaced v-centered"
                    key={name}
                  >
                    <span>{name}</span>
                    <Shortcut text={key} />
                  </S.RowContainer>
                ))}
              </S.ShortCutSection>
            )
        )}

      {settings.config.type === 'blades' && (
        <S.Message>{bladesShortcutMessage}</S.Message>
      )}
    </div>
  )
}

export default SectionsShortcut
